/* eslint-disable */
// @ts-nocheck
/**
 * AUTO-GENERATED by scripts/generateFilterExpressionParser.ts — DO NOT EDIT.
 *
 * Precompiled, eval-free parser for AI/MCP filter expressions. Regenerate with
 * `pnpm -F common generate:filter-expression-parser` after editing grammar.ts.
 */
export const filterExpressionParser /*
 * Generated by PEG.js 0.10.0.
 *
 * http://pegjs.org/
 */ = (function () {
    'use strict';
    function peg$subclass(child, parent) {
        function ctor() {
            this.constructor = child;
        }
        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
    }
    function peg$SyntaxError(message, expected, found, location) {
        this.message = message;
        this.expected = expected;
        this.found = found;
        this.location = location;
        this.name = 'SyntaxError';
        if (typeof Error.captureStackTrace === 'function') {
            Error.captureStackTrace(this, peg$SyntaxError);
        }
    }
    peg$subclass(peg$SyntaxError, Error);
    peg$SyntaxError.buildMessage = function (expected, found) {
        var DESCRIBE_EXPECTATION_FNS = {
            literal: function (expectation) {
                return '"' + literalEscape(expectation.text) + '"';
            },
            class: function (expectation) {
                var escapedParts = '', i;
                for (i = 0; i < expectation.parts.length; i++) {
                    escapedParts +=
                        expectation.parts[i] instanceof Array
                            ? classEscape(expectation.parts[i][0]) +
                                '-' +
                                classEscape(expectation.parts[i][1])
                            : classEscape(expectation.parts[i]);
                }
                return ('[' + (expectation.inverted ? '^' : '') + escapedParts + ']');
            },
            any: function (expectation) {
                return 'any character';
            },
            end: function (expectation) {
                return 'end of input';
            },
            other: function (expectation) {
                return expectation.description;
            },
        };
        function hex(ch) {
            return ch.charCodeAt(0).toString(16).toUpperCase();
        }
        function literalEscape(s) {
            return s
                .replace(/\\/g, '\\\\')
                .replace(/"/g, '\\"')
                .replace(/\0/g, '\\0')
                .replace(/\t/g, '\\t')
                .replace(/\n/g, '\\n')
                .replace(/\r/g, '\\r')
                .replace(/[\x00-\x0F]/g, function (ch) {
                return '\\x0' + hex(ch);
            })
                .replace(/[\x10-\x1F\x7F-\x9F]/g, function (ch) {
                return '\\x' + hex(ch);
            });
        }
        function classEscape(s) {
            return s
                .replace(/\\/g, '\\\\')
                .replace(/\]/g, '\\]')
                .replace(/\^/g, '\\^')
                .replace(/-/g, '\\-')
                .replace(/\0/g, '\\0')
                .replace(/\t/g, '\\t')
                .replace(/\n/g, '\\n')
                .replace(/\r/g, '\\r')
                .replace(/[\x00-\x0F]/g, function (ch) {
                return '\\x0' + hex(ch);
            })
                .replace(/[\x10-\x1F\x7F-\x9F]/g, function (ch) {
                return '\\x' + hex(ch);
            });
        }
        function describeExpectation(expectation) {
            return DESCRIBE_EXPECTATION_FNS[expectation.type](expectation);
        }
        function describeExpected(expected) {
            var descriptions = new Array(expected.length), i, j;
            for (i = 0; i < expected.length; i++) {
                descriptions[i] = describeExpectation(expected[i]);
            }
            descriptions.sort();
            if (descriptions.length > 0) {
                for (i = 1, j = 1; i < descriptions.length; i++) {
                    if (descriptions[i - 1] !== descriptions[i]) {
                        descriptions[j] = descriptions[i];
                        j++;
                    }
                }
                descriptions.length = j;
            }
            switch (descriptions.length) {
                case 1:
                    return descriptions[0];
                case 2:
                    return descriptions[0] + ' or ' + descriptions[1];
                default:
                    return (descriptions.slice(0, -1).join(', ') +
                        ', or ' +
                        descriptions[descriptions.length - 1]);
            }
        }
        function describeFound(found) {
            return found ? '"' + literalEscape(found) + '"' : 'end of input';
        }
        return ('Expected ' +
            describeExpected(expected) +
            ' but ' +
            describeFound(found) +
            ' found.');
    };
    function peg$parse(input, options) {
        options = options !== void 0 ? options : {};
        var peg$FAILED = {}, peg$startRuleFunctions = { START: peg$parseSTART }, peg$startRuleFunction = peg$parseSTART, peg$c0 = peg$anyExpectation(), peg$c1 = function (expression) {
            return expression;
        }, peg$c2 = function (first, connector, rule) {
            return { connector: connector, rule: rule };
        }, peg$c3 = function (first, rest) {
            var connector = null;
            for (var index = 0; index < rest.length; index += 1) {
                if (connector === null) {
                    connector = rest[index].connector.value;
                }
                else if (connector !== rest[index].connector.value) {
                    return {
                        kind: 'parseError',
                        code: 'FILTER_EXPRESSION_MIXED_CONNECTORS',
                        message: 'A flat filter expression cannot mix AND and OR connectors.',
                        span: rest[index].connector.span,
                    };
                }
            }
            var rules = [first].concat(rest.map(function (item) {
                return item.rule;
            }));
            return {
                kind: 'expression',
                connector: connector,
                rules: rules,
                span: {
                    start: first.span.start,
                    end: rules[rules.length - 1].span.end,
                },
            };
        }, peg$c4 = '=', peg$c5 = peg$literalExpectation('=', false), peg$c6 = function (field, operator) {
            return {
                kind: 'rule',
                field: field,
                operator: operator,
                arguments: [],
                span: { start: field.span.start, end: operator.span.end },
            };
        }, peg$c7 = function (field, operator, values, value) {
            return value;
        }, peg$c8 = function (field, operator, values, settings) {
            var rule = {
                kind: 'rule',
                field: field,
                operator: operator,
                arguments: values,
                span: {
                    start: field.span.start,
                    end: settings === null
                        ? values[values.length - 1].span.end
                        : settings.span.end,
                },
            };
            if (settings !== null) {
                rule.settings = settings;
            }
            return rule;
        }, peg$c9 = '{', peg$c10 = peg$literalExpectation('{', false), peg$c11 = ',', peg$c12 = peg$literalExpectation(',', false), peg$c13 = function (first, setting) {
            return setting;
        }, peg$c14 = '}', peg$c15 = peg$literalExpectation('}', false), peg$c16 = function (first, rest) {
            return {
                kind: 'settings',
                entries: [first].concat(rest),
                span: location(),
            };
        }, peg$c17 = ':', peg$c18 = peg$literalExpectation(':', false), peg$c19 = function (name, value) {
            return {
                kind: 'setting',
                name: name,
                value: value,
                span: { start: name.span.start, end: value.span.end },
            };
        }, peg$c20 = /^[A-Za-z]/, peg$c21 = peg$classExpectation([
            ['A', 'Z'],
            ['a', 'z'],
        ], false, false), peg$c22 = /^[A-Za-z0-9_]/, peg$c23 = peg$classExpectation([['A', 'Z'], ['a', 'z'], ['0', '9'], '_'], false, false), peg$c24 = function (value) {
            return node('settingName', value, location());
        }, peg$c25 = /^[A-Za-z0-9_.\-]/, peg$c26 = peg$classExpectation([['A', 'Z'], ['a', 'z'], ['0', '9'], '_', '.', '-'], false, false), peg$c27 = function (value) {
            return node('field', value, location());
        }, peg$c28 = '`', peg$c29 = peg$literalExpectation('`', false), peg$c30 = function (characters) {
            return node('field', characters.join(''), location());
        }, peg$c31 = /^[^\0-\x1F\\`]/, peg$c32 = peg$classExpectation([['\0', '\x1F'], '\\', '`'], true, false), peg$c33 = function (value) {
            return value;
        }, peg$c34 = 'notNull', peg$c35 = peg$literalExpectation('notNull', false), peg$c36 = 'isNull', peg$c37 = peg$literalExpectation('isNull', false), peg$c38 = function (value) {
            return node('operator', value, location());
        }, peg$c39 = 'greaterThanOrEqual', peg$c40 = peg$literalExpectation('greaterThanOrEqual', false), peg$c41 = 'lessThanOrEqual', peg$c42 = peg$literalExpectation('lessThanOrEqual', false), peg$c43 = 'notInTheCurrent', peg$c44 = peg$literalExpectation('notInTheCurrent', false), peg$c45 = 'doesNotInclude', peg$c46 = peg$literalExpectation('doesNotInclude', false), peg$c47 = 'notInThePast', peg$c48 = peg$literalExpectation('notInThePast', false), peg$c49 = 'inTheCurrent', peg$c50 = peg$literalExpectation('inTheCurrent', false), peg$c51 = 'notInBetween', peg$c52 = peg$literalExpectation('notInBetween', false), peg$c53 = 'greaterThan', peg$c54 = peg$literalExpectation('greaterThan', false), peg$c55 = 'startsWith', peg$c56 = peg$literalExpectation('startsWith', false), peg$c57 = 'notEquals', peg$c58 = peg$literalExpectation('notEquals', false), peg$c59 = 'inThePast', peg$c60 = peg$literalExpectation('inThePast', false), peg$c61 = 'inTheNext', peg$c62 = peg$literalExpectation('inTheNext', false), peg$c63 = 'inBetween', peg$c64 = peg$literalExpectation('inBetween', false), peg$c65 = 'endsWith', peg$c66 = peg$literalExpectation('endsWith', false), peg$c67 = 'lessThan', peg$c68 = peg$literalExpectation('lessThan', false), peg$c69 = 'include', peg$c70 = peg$literalExpectation('include', false), peg$c71 = 'equals', peg$c72 = peg$literalExpectation('equals', false), peg$c73 = 'and', peg$c74 = peg$literalExpectation('AND', true), peg$c75 = 'or', peg$c76 = peg$literalExpectation('OR', true), peg$c77 = function (value) {
            return node('connector', value.toLowerCase(), location());
        }, peg$c78 = function (first, scalar) {
            return scalar;
        }, peg$c79 = function (first, rest) {
            return [first].concat(rest);
        }, peg$c80 = 'null', peg$c81 = peg$literalExpectation('null', true), peg$c82 = function (value) {
            return node('bareNull', value, location());
        }, peg$c83 = function (value) {
            return node('bare', value, location());
        }, peg$c84 = /^[ \t\r\n,{}()'"=\\]/, peg$c85 = peg$classExpectation([
            ' ',
            '\t',
            '\r',
            '\n',
            ',',
            '{',
            '}',
            '(',
            ')',
            "'",
            '"',
            '=',
            '\\',
        ], false, false), peg$c86 = "'", peg$c87 = peg$literalExpectation("'", false), peg$c88 = function (characters) {
            return node('quoted', characters.join(''), location());
        }, peg$c89 = /^[^\0-\x1F'\\]/, peg$c90 = peg$classExpectation([['\0', '\x1F'], "'", '\\'], true, false), peg$c91 = '"', peg$c92 = peg$literalExpectation('"', false), peg$c93 = /^[^\0-\x1F"\\]/, peg$c94 = peg$classExpectation([['\0', '\x1F'], '"', '\\'], true, false), peg$c95 = '\\', peg$c96 = peg$literalExpectation('\\', false), peg$c97 = '/', peg$c98 = peg$literalExpectation('/', false), peg$c99 = 'b', peg$c100 = peg$literalExpectation('b', false), peg$c101 = function () {
            return '\b';
        }, peg$c102 = 'f', peg$c103 = peg$literalExpectation('f', false), peg$c104 = function () {
            return '\f';
        }, peg$c105 = 'n', peg$c106 = peg$literalExpectation('n', false), peg$c107 = function () {
            return '\n';
        }, peg$c108 = 'r', peg$c109 = peg$literalExpectation('r', false), peg$c110 = function () {
            return '\r';
        }, peg$c111 = 't', peg$c112 = peg$literalExpectation('t', false), peg$c113 = function () {
            return '\t';
        }, peg$c114 = 'u', peg$c115 = peg$literalExpectation('u', false), peg$c116 = /^[0-9a-f]/i, peg$c117 = peg$classExpectation([
            ['0', '9'],
            ['a', 'f'],
        ], false, true), peg$c118 = function (digits) {
            return String.fromCharCode(parseInt(digits, 16));
        }, peg$c119 = function (sequence) {
            return sequence;
        }, peg$c120 = /^[ \t\r\n]/, peg$c121 = peg$classExpectation([' ', '\t', '\r', '\n'], false, false), peg$currPos = 0, peg$savedPos = 0, peg$posDetailsCache = [{ line: 1, column: 1 }], peg$maxFailPos = 0, peg$maxFailExpected = [], peg$silentFails = 0, peg$result;
        if ('startRule' in options) {
            if (!(options.startRule in peg$startRuleFunctions)) {
                throw new Error('Can\'t start parsing from rule "' +
                    options.startRule +
                    '".');
            }
            peg$startRuleFunction = peg$startRuleFunctions[options.startRule];
        }
        function text() {
            return input.substring(peg$savedPos, peg$currPos);
        }
        function location() {
            return peg$computeLocation(peg$savedPos, peg$currPos);
        }
        function expected(description, location) {
            location =
                location !== void 0
                    ? location
                    : peg$computeLocation(peg$savedPos, peg$currPos);
            throw peg$buildStructuredError([peg$otherExpectation(description)], input.substring(peg$savedPos, peg$currPos), location);
        }
        function error(message, location) {
            location =
                location !== void 0
                    ? location
                    : peg$computeLocation(peg$savedPos, peg$currPos);
            throw peg$buildSimpleError(message, location);
        }
        function peg$literalExpectation(text, ignoreCase) {
            return { type: 'literal', text: text, ignoreCase: ignoreCase };
        }
        function peg$classExpectation(parts, inverted, ignoreCase) {
            return {
                type: 'class',
                parts: parts,
                inverted: inverted,
                ignoreCase: ignoreCase,
            };
        }
        function peg$anyExpectation() {
            return { type: 'any' };
        }
        function peg$endExpectation() {
            return { type: 'end' };
        }
        function peg$otherExpectation(description) {
            return { type: 'other', description: description };
        }
        function peg$computePosDetails(pos) {
            var details = peg$posDetailsCache[pos], p;
            if (details) {
                return details;
            }
            else {
                p = pos - 1;
                while (!peg$posDetailsCache[p]) {
                    p--;
                }
                details = peg$posDetailsCache[p];
                details = {
                    line: details.line,
                    column: details.column,
                };
                while (p < pos) {
                    if (input.charCodeAt(p) === 10) {
                        details.line++;
                        details.column = 1;
                    }
                    else {
                        details.column++;
                    }
                    p++;
                }
                peg$posDetailsCache[pos] = details;
                return details;
            }
        }
        function peg$computeLocation(startPos, endPos) {
            var startPosDetails = peg$computePosDetails(startPos), endPosDetails = peg$computePosDetails(endPos);
            return {
                start: {
                    offset: startPos,
                    line: startPosDetails.line,
                    column: startPosDetails.column,
                },
                end: {
                    offset: endPos,
                    line: endPosDetails.line,
                    column: endPosDetails.column,
                },
            };
        }
        function peg$fail(expected) {
            if (peg$currPos < peg$maxFailPos) {
                return;
            }
            if (peg$currPos > peg$maxFailPos) {
                peg$maxFailPos = peg$currPos;
                peg$maxFailExpected = [];
            }
            peg$maxFailExpected.push(expected);
        }
        function peg$buildSimpleError(message, location) {
            return new peg$SyntaxError(message, null, null, location);
        }
        function peg$buildStructuredError(expected, found, location) {
            return new peg$SyntaxError(peg$SyntaxError.buildMessage(expected, found), expected, found, location);
        }
        function peg$parseSTART() {
            var s0, s1, s2, s3, s4, s5;
            s0 = peg$currPos;
            s1 = peg$parse_();
            if (s1 !== peg$FAILED) {
                s2 = peg$parseEXPRESSION();
                if (s2 !== peg$FAILED) {
                    s3 = peg$parse_();
                    if (s3 !== peg$FAILED) {
                        s4 = peg$currPos;
                        peg$silentFails++;
                        if (input.length > peg$currPos) {
                            s5 = input.charAt(peg$currPos);
                            peg$currPos++;
                        }
                        else {
                            s5 = peg$FAILED;
                            if (peg$silentFails === 0) {
                                peg$fail(peg$c0);
                            }
                        }
                        peg$silentFails--;
                        if (s5 === peg$FAILED) {
                            s4 = void 0;
                        }
                        else {
                            peg$currPos = s4;
                            s4 = peg$FAILED;
                        }
                        if (s4 !== peg$FAILED) {
                            peg$savedPos = s0;
                            s1 = peg$c1(s2);
                            s0 = s1;
                        }
                        else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    }
                    else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parseEXPRESSION() {
            var s0, s1, s2, s3, s4, s5, s6, s7;
            s0 = peg$currPos;
            s1 = peg$parseRULE();
            if (s1 !== peg$FAILED) {
                s2 = [];
                s3 = peg$currPos;
                s4 = peg$parse__();
                if (s4 !== peg$FAILED) {
                    s5 = peg$parseCONNECTOR();
                    if (s5 !== peg$FAILED) {
                        s6 = peg$parse__();
                        if (s6 !== peg$FAILED) {
                            s7 = peg$parseRULE();
                            if (s7 !== peg$FAILED) {
                                peg$savedPos = s3;
                                s4 = peg$c2(s1, s5, s7);
                                s3 = s4;
                            }
                            else {
                                peg$currPos = s3;
                                s3 = peg$FAILED;
                            }
                        }
                        else {
                            peg$currPos = s3;
                            s3 = peg$FAILED;
                        }
                    }
                    else {
                        peg$currPos = s3;
                        s3 = peg$FAILED;
                    }
                }
                else {
                    peg$currPos = s3;
                    s3 = peg$FAILED;
                }
                while (s3 !== peg$FAILED) {
                    s2.push(s3);
                    s3 = peg$currPos;
                    s4 = peg$parse__();
                    if (s4 !== peg$FAILED) {
                        s5 = peg$parseCONNECTOR();
                        if (s5 !== peg$FAILED) {
                            s6 = peg$parse__();
                            if (s6 !== peg$FAILED) {
                                s7 = peg$parseRULE();
                                if (s7 !== peg$FAILED) {
                                    peg$savedPos = s3;
                                    s4 = peg$c2(s1, s5, s7);
                                    s3 = s4;
                                }
                                else {
                                    peg$currPos = s3;
                                    s3 = peg$FAILED;
                                }
                            }
                            else {
                                peg$currPos = s3;
                                s3 = peg$FAILED;
                            }
                        }
                        else {
                            peg$currPos = s3;
                            s3 = peg$FAILED;
                        }
                    }
                    else {
                        peg$currPos = s3;
                        s3 = peg$FAILED;
                    }
                }
                if (s2 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c3(s1, s2);
                    s0 = s1;
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parseRULE() {
            var s0;
            s0 = peg$parsePRESENCE_RULE();
            if (s0 === peg$FAILED) {
                s0 = peg$parseVALUE_RULE();
            }
            return s0;
        }
        function peg$parsePRESENCE_RULE() {
            var s0, s1, s2, s3, s4, s5, s6, s7;
            s0 = peg$currPos;
            s1 = peg$parseFIELD();
            if (s1 !== peg$FAILED) {
                s2 = peg$parse__();
                if (s2 !== peg$FAILED) {
                    s3 = peg$parsePRESENCE_OPERATOR();
                    if (s3 !== peg$FAILED) {
                        s4 = peg$currPos;
                        peg$silentFails++;
                        s5 = peg$currPos;
                        s6 = peg$parse_();
                        if (s6 !== peg$FAILED) {
                            if (input.charCodeAt(peg$currPos) === 61) {
                                s7 = peg$c4;
                                peg$currPos++;
                            }
                            else {
                                s7 = peg$FAILED;
                                if (peg$silentFails === 0) {
                                    peg$fail(peg$c5);
                                }
                            }
                            if (s7 !== peg$FAILED) {
                                s6 = [s6, s7];
                                s5 = s6;
                            }
                            else {
                                peg$currPos = s5;
                                s5 = peg$FAILED;
                            }
                        }
                        else {
                            peg$currPos = s5;
                            s5 = peg$FAILED;
                        }
                        peg$silentFails--;
                        if (s5 === peg$FAILED) {
                            s4 = void 0;
                        }
                        else {
                            peg$currPos = s4;
                            s4 = peg$FAILED;
                        }
                        if (s4 !== peg$FAILED) {
                            peg$savedPos = s0;
                            s1 = peg$c6(s1, s3);
                            s0 = s1;
                        }
                        else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    }
                    else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parseVALUE_RULE() {
            var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10;
            s0 = peg$currPos;
            s1 = peg$parseFIELD();
            if (s1 !== peg$FAILED) {
                s2 = peg$parse__();
                if (s2 !== peg$FAILED) {
                    s3 = peg$parseVALUE_OPERATOR();
                    if (s3 !== peg$FAILED) {
                        s4 = peg$parse_();
                        if (s4 !== peg$FAILED) {
                            if (input.charCodeAt(peg$currPos) === 61) {
                                s5 = peg$c4;
                                peg$currPos++;
                            }
                            else {
                                s5 = peg$FAILED;
                                if (peg$silentFails === 0) {
                                    peg$fail(peg$c5);
                                }
                            }
                            if (s5 !== peg$FAILED) {
                                s6 = peg$parse_();
                                if (s6 !== peg$FAILED) {
                                    s7 = peg$parseARGUMENTS();
                                    if (s7 !== peg$FAILED) {
                                        s8 = peg$currPos;
                                        s9 = peg$parse_();
                                        if (s9 !== peg$FAILED) {
                                            s10 = peg$parseSETTINGS();
                                            if (s10 !== peg$FAILED) {
                                                peg$savedPos = s8;
                                                s9 = peg$c7(s1, s3, s7, s10);
                                                s8 = s9;
                                            }
                                            else {
                                                peg$currPos = s8;
                                                s8 = peg$FAILED;
                                            }
                                        }
                                        else {
                                            peg$currPos = s8;
                                            s8 = peg$FAILED;
                                        }
                                        if (s8 === peg$FAILED) {
                                            s8 = null;
                                        }
                                        if (s8 !== peg$FAILED) {
                                            peg$savedPos = s0;
                                            s1 = peg$c8(s1, s3, s7, s8);
                                            s0 = s1;
                                        }
                                        else {
                                            peg$currPos = s0;
                                            s0 = peg$FAILED;
                                        }
                                    }
                                    else {
                                        peg$currPos = s0;
                                        s0 = peg$FAILED;
                                    }
                                }
                                else {
                                    peg$currPos = s0;
                                    s0 = peg$FAILED;
                                }
                            }
                            else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                            }
                        }
                        else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    }
                    else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parseSETTINGS() {
            var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9;
            s0 = peg$currPos;
            if (input.charCodeAt(peg$currPos) === 123) {
                s1 = peg$c9;
                peg$currPos++;
            }
            else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$c10);
                }
            }
            if (s1 !== peg$FAILED) {
                s2 = peg$parse_();
                if (s2 !== peg$FAILED) {
                    s3 = peg$parseSETTING();
                    if (s3 !== peg$FAILED) {
                        s4 = [];
                        s5 = peg$currPos;
                        s6 = peg$parse_();
                        if (s6 !== peg$FAILED) {
                            if (input.charCodeAt(peg$currPos) === 44) {
                                s7 = peg$c11;
                                peg$currPos++;
                            }
                            else {
                                s7 = peg$FAILED;
                                if (peg$silentFails === 0) {
                                    peg$fail(peg$c12);
                                }
                            }
                            if (s7 !== peg$FAILED) {
                                s8 = peg$parse_();
                                if (s8 !== peg$FAILED) {
                                    s9 = peg$parseSETTING();
                                    if (s9 !== peg$FAILED) {
                                        peg$savedPos = s5;
                                        s6 = peg$c13(s3, s9);
                                        s5 = s6;
                                    }
                                    else {
                                        peg$currPos = s5;
                                        s5 = peg$FAILED;
                                    }
                                }
                                else {
                                    peg$currPos = s5;
                                    s5 = peg$FAILED;
                                }
                            }
                            else {
                                peg$currPos = s5;
                                s5 = peg$FAILED;
                            }
                        }
                        else {
                            peg$currPos = s5;
                            s5 = peg$FAILED;
                        }
                        while (s5 !== peg$FAILED) {
                            s4.push(s5);
                            s5 = peg$currPos;
                            s6 = peg$parse_();
                            if (s6 !== peg$FAILED) {
                                if (input.charCodeAt(peg$currPos) === 44) {
                                    s7 = peg$c11;
                                    peg$currPos++;
                                }
                                else {
                                    s7 = peg$FAILED;
                                    if (peg$silentFails === 0) {
                                        peg$fail(peg$c12);
                                    }
                                }
                                if (s7 !== peg$FAILED) {
                                    s8 = peg$parse_();
                                    if (s8 !== peg$FAILED) {
                                        s9 = peg$parseSETTING();
                                        if (s9 !== peg$FAILED) {
                                            peg$savedPos = s5;
                                            s6 = peg$c13(s3, s9);
                                            s5 = s6;
                                        }
                                        else {
                                            peg$currPos = s5;
                                            s5 = peg$FAILED;
                                        }
                                    }
                                    else {
                                        peg$currPos = s5;
                                        s5 = peg$FAILED;
                                    }
                                }
                                else {
                                    peg$currPos = s5;
                                    s5 = peg$FAILED;
                                }
                            }
                            else {
                                peg$currPos = s5;
                                s5 = peg$FAILED;
                            }
                        }
                        if (s4 !== peg$FAILED) {
                            s5 = peg$parse_();
                            if (s5 !== peg$FAILED) {
                                if (input.charCodeAt(peg$currPos) === 125) {
                                    s6 = peg$c14;
                                    peg$currPos++;
                                }
                                else {
                                    s6 = peg$FAILED;
                                    if (peg$silentFails === 0) {
                                        peg$fail(peg$c15);
                                    }
                                }
                                if (s6 !== peg$FAILED) {
                                    peg$savedPos = s0;
                                    s1 = peg$c16(s3, s4);
                                    s0 = s1;
                                }
                                else {
                                    peg$currPos = s0;
                                    s0 = peg$FAILED;
                                }
                            }
                            else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                            }
                        }
                        else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    }
                    else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parseSETTING() {
            var s0, s1, s2, s3, s4, s5;
            s0 = peg$currPos;
            s1 = peg$parseSETTING_NAME();
            if (s1 !== peg$FAILED) {
                s2 = peg$parse_();
                if (s2 !== peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 58) {
                        s3 = peg$c17;
                        peg$currPos++;
                    }
                    else {
                        s3 = peg$FAILED;
                        if (peg$silentFails === 0) {
                            peg$fail(peg$c18);
                        }
                    }
                    if (s3 !== peg$FAILED) {
                        s4 = peg$parse_();
                        if (s4 !== peg$FAILED) {
                            s5 = peg$parseSCALAR();
                            if (s5 !== peg$FAILED) {
                                peg$savedPos = s0;
                                s1 = peg$c19(s1, s5);
                                s0 = s1;
                            }
                            else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                            }
                        }
                        else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    }
                    else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parseSETTING_NAME() {
            var s0, s1, s2, s3, s4, s5;
            s0 = peg$currPos;
            s1 = peg$currPos;
            s2 = peg$currPos;
            if (peg$c20.test(input.charAt(peg$currPos))) {
                s3 = input.charAt(peg$currPos);
                peg$currPos++;
            }
            else {
                s3 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$c21);
                }
            }
            if (s3 !== peg$FAILED) {
                s4 = [];
                if (peg$c22.test(input.charAt(peg$currPos))) {
                    s5 = input.charAt(peg$currPos);
                    peg$currPos++;
                }
                else {
                    s5 = peg$FAILED;
                    if (peg$silentFails === 0) {
                        peg$fail(peg$c23);
                    }
                }
                while (s5 !== peg$FAILED) {
                    s4.push(s5);
                    if (peg$c22.test(input.charAt(peg$currPos))) {
                        s5 = input.charAt(peg$currPos);
                        peg$currPos++;
                    }
                    else {
                        s5 = peg$FAILED;
                        if (peg$silentFails === 0) {
                            peg$fail(peg$c23);
                        }
                    }
                }
                if (s4 !== peg$FAILED) {
                    s3 = [s3, s4];
                    s2 = s3;
                }
                else {
                    peg$currPos = s2;
                    s2 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s2;
                s2 = peg$FAILED;
            }
            if (s2 !== peg$FAILED) {
                s1 = input.substring(s1, peg$currPos);
            }
            else {
                s1 = s2;
            }
            if (s1 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c24(s1);
            }
            s0 = s1;
            return s0;
        }
        function peg$parseFIELD() {
            var s0;
            s0 = peg$parseQUOTED_FIELD();
            if (s0 === peg$FAILED) {
                s0 = peg$parseSAFE_FIELD();
            }
            return s0;
        }
        function peg$parseSAFE_FIELD() {
            var s0, s1, s2, s3, s4;
            s0 = peg$currPos;
            s1 = peg$currPos;
            peg$silentFails++;
            s2 = peg$parseRESERVED_CONNECTOR();
            peg$silentFails--;
            if (s2 === peg$FAILED) {
                s1 = void 0;
            }
            else {
                peg$currPos = s1;
                s1 = peg$FAILED;
            }
            if (s1 !== peg$FAILED) {
                s2 = peg$currPos;
                s3 = [];
                if (peg$c25.test(input.charAt(peg$currPos))) {
                    s4 = input.charAt(peg$currPos);
                    peg$currPos++;
                }
                else {
                    s4 = peg$FAILED;
                    if (peg$silentFails === 0) {
                        peg$fail(peg$c26);
                    }
                }
                if (s4 !== peg$FAILED) {
                    while (s4 !== peg$FAILED) {
                        s3.push(s4);
                        if (peg$c25.test(input.charAt(peg$currPos))) {
                            s4 = input.charAt(peg$currPos);
                            peg$currPos++;
                        }
                        else {
                            s4 = peg$FAILED;
                            if (peg$silentFails === 0) {
                                peg$fail(peg$c26);
                            }
                        }
                    }
                }
                else {
                    s3 = peg$FAILED;
                }
                if (s3 !== peg$FAILED) {
                    s2 = input.substring(s2, peg$currPos);
                }
                else {
                    s2 = s3;
                }
                if (s2 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c27(s2);
                    s0 = s1;
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parseQUOTED_FIELD() {
            var s0, s1, s2, s3;
            s0 = peg$currPos;
            if (input.charCodeAt(peg$currPos) === 96) {
                s1 = peg$c28;
                peg$currPos++;
            }
            else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$c29);
                }
            }
            if (s1 !== peg$FAILED) {
                s2 = [];
                s3 = peg$parseFIELD_CHARACTER();
                if (s3 !== peg$FAILED) {
                    while (s3 !== peg$FAILED) {
                        s2.push(s3);
                        s3 = peg$parseFIELD_CHARACTER();
                    }
                }
                else {
                    s2 = peg$FAILED;
                }
                if (s2 !== peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 96) {
                        s3 = peg$c28;
                        peg$currPos++;
                    }
                    else {
                        s3 = peg$FAILED;
                        if (peg$silentFails === 0) {
                            peg$fail(peg$c29);
                        }
                    }
                    if (s3 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c30(s2);
                        s0 = s1;
                    }
                    else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parseFIELD_CHARACTER() {
            var s0, s1;
            s0 = peg$parseESCAPE();
            if (s0 === peg$FAILED) {
                s0 = peg$currPos;
                if (peg$c31.test(input.charAt(peg$currPos))) {
                    s1 = input.charAt(peg$currPos);
                    peg$currPos++;
                }
                else {
                    s1 = peg$FAILED;
                    if (peg$silentFails === 0) {
                        peg$fail(peg$c32);
                    }
                }
                if (s1 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c33(s1);
                }
                s0 = s1;
            }
            return s0;
        }
        function peg$parsePRESENCE_OPERATOR() {
            var s0, s1, s2, s3;
            s0 = peg$currPos;
            if (input.substr(peg$currPos, 7) === peg$c34) {
                s1 = peg$c34;
                peg$currPos += 7;
            }
            else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$c35);
                }
            }
            if (s1 === peg$FAILED) {
                if (input.substr(peg$currPos, 6) === peg$c36) {
                    s1 = peg$c36;
                    peg$currPos += 6;
                }
                else {
                    s1 = peg$FAILED;
                    if (peg$silentFails === 0) {
                        peg$fail(peg$c37);
                    }
                }
            }
            if (s1 !== peg$FAILED) {
                s2 = peg$currPos;
                peg$silentFails++;
                s3 = peg$parseIDENTIFIER_CHARACTER();
                peg$silentFails--;
                if (s3 === peg$FAILED) {
                    s2 = void 0;
                }
                else {
                    peg$currPos = s2;
                    s2 = peg$FAILED;
                }
                if (s2 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c38(s1);
                    s0 = s1;
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parseVALUE_OPERATOR() {
            var s0, s1, s2, s3;
            s0 = peg$currPos;
            if (input.substr(peg$currPos, 18) === peg$c39) {
                s1 = peg$c39;
                peg$currPos += 18;
            }
            else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$c40);
                }
            }
            if (s1 === peg$FAILED) {
                if (input.substr(peg$currPos, 15) === peg$c41) {
                    s1 = peg$c41;
                    peg$currPos += 15;
                }
                else {
                    s1 = peg$FAILED;
                    if (peg$silentFails === 0) {
                        peg$fail(peg$c42);
                    }
                }
                if (s1 === peg$FAILED) {
                    if (input.substr(peg$currPos, 15) === peg$c43) {
                        s1 = peg$c43;
                        peg$currPos += 15;
                    }
                    else {
                        s1 = peg$FAILED;
                        if (peg$silentFails === 0) {
                            peg$fail(peg$c44);
                        }
                    }
                    if (s1 === peg$FAILED) {
                        if (input.substr(peg$currPos, 14) === peg$c45) {
                            s1 = peg$c45;
                            peg$currPos += 14;
                        }
                        else {
                            s1 = peg$FAILED;
                            if (peg$silentFails === 0) {
                                peg$fail(peg$c46);
                            }
                        }
                        if (s1 === peg$FAILED) {
                            if (input.substr(peg$currPos, 12) === peg$c47) {
                                s1 = peg$c47;
                                peg$currPos += 12;
                            }
                            else {
                                s1 = peg$FAILED;
                                if (peg$silentFails === 0) {
                                    peg$fail(peg$c48);
                                }
                            }
                            if (s1 === peg$FAILED) {
                                if (input.substr(peg$currPos, 12) === peg$c49) {
                                    s1 = peg$c49;
                                    peg$currPos += 12;
                                }
                                else {
                                    s1 = peg$FAILED;
                                    if (peg$silentFails === 0) {
                                        peg$fail(peg$c50);
                                    }
                                }
                                if (s1 === peg$FAILED) {
                                    if (input.substr(peg$currPos, 12) ===
                                        peg$c51) {
                                        s1 = peg$c51;
                                        peg$currPos += 12;
                                    }
                                    else {
                                        s1 = peg$FAILED;
                                        if (peg$silentFails === 0) {
                                            peg$fail(peg$c52);
                                        }
                                    }
                                    if (s1 === peg$FAILED) {
                                        if (input.substr(peg$currPos, 11) ===
                                            peg$c53) {
                                            s1 = peg$c53;
                                            peg$currPos += 11;
                                        }
                                        else {
                                            s1 = peg$FAILED;
                                            if (peg$silentFails === 0) {
                                                peg$fail(peg$c54);
                                            }
                                        }
                                        if (s1 === peg$FAILED) {
                                            if (input.substr(peg$currPos, 10) === peg$c55) {
                                                s1 = peg$c55;
                                                peg$currPos += 10;
                                            }
                                            else {
                                                s1 = peg$FAILED;
                                                if (peg$silentFails === 0) {
                                                    peg$fail(peg$c56);
                                                }
                                            }
                                            if (s1 === peg$FAILED) {
                                                if (input.substr(peg$currPos, 9) === peg$c57) {
                                                    s1 = peg$c57;
                                                    peg$currPos += 9;
                                                }
                                                else {
                                                    s1 = peg$FAILED;
                                                    if (peg$silentFails === 0) {
                                                        peg$fail(peg$c58);
                                                    }
                                                }
                                                if (s1 === peg$FAILED) {
                                                    if (input.substr(peg$currPos, 9) === peg$c59) {
                                                        s1 = peg$c59;
                                                        peg$currPos += 9;
                                                    }
                                                    else {
                                                        s1 = peg$FAILED;
                                                        if (peg$silentFails ===
                                                            0) {
                                                            peg$fail(peg$c60);
                                                        }
                                                    }
                                                    if (s1 === peg$FAILED) {
                                                        if (input.substr(peg$currPos, 9) === peg$c61) {
                                                            s1 = peg$c61;
                                                            peg$currPos += 9;
                                                        }
                                                        else {
                                                            s1 = peg$FAILED;
                                                            if (peg$silentFails ===
                                                                0) {
                                                                peg$fail(peg$c62);
                                                            }
                                                        }
                                                        if (s1 === peg$FAILED) {
                                                            if (input.substr(peg$currPos, 9) === peg$c63) {
                                                                s1 = peg$c63;
                                                                peg$currPos += 9;
                                                            }
                                                            else {
                                                                s1 = peg$FAILED;
                                                                if (peg$silentFails ===
                                                                    0) {
                                                                    peg$fail(peg$c64);
                                                                }
                                                            }
                                                            if (s1 ===
                                                                peg$FAILED) {
                                                                if (input.substr(peg$currPos, 8) ===
                                                                    peg$c65) {
                                                                    s1 =
                                                                        peg$c65;
                                                                    peg$currPos += 8;
                                                                }
                                                                else {
                                                                    s1 =
                                                                        peg$FAILED;
                                                                    if (peg$silentFails ===
                                                                        0) {
                                                                        peg$fail(peg$c66);
                                                                    }
                                                                }
                                                                if (s1 ===
                                                                    peg$FAILED) {
                                                                    if (input.substr(peg$currPos, 8) ===
                                                                        peg$c67) {
                                                                        s1 =
                                                                            peg$c67;
                                                                        peg$currPos += 8;
                                                                    }
                                                                    else {
                                                                        s1 =
                                                                            peg$FAILED;
                                                                        if (peg$silentFails ===
                                                                            0) {
                                                                            peg$fail(peg$c68);
                                                                        }
                                                                    }
                                                                    if (s1 ===
                                                                        peg$FAILED) {
                                                                        if (input.substr(peg$currPos, 7) ===
                                                                            peg$c69) {
                                                                            s1 =
                                                                                peg$c69;
                                                                            peg$currPos += 7;
                                                                        }
                                                                        else {
                                                                            s1 =
                                                                                peg$FAILED;
                                                                            if (peg$silentFails ===
                                                                                0) {
                                                                                peg$fail(peg$c70);
                                                                            }
                                                                        }
                                                                        if (s1 ===
                                                                            peg$FAILED) {
                                                                            if (input.substr(peg$currPos, 6) ===
                                                                                peg$c71) {
                                                                                s1 =
                                                                                    peg$c71;
                                                                                peg$currPos += 6;
                                                                            }
                                                                            else {
                                                                                s1 =
                                                                                    peg$FAILED;
                                                                                if (peg$silentFails ===
                                                                                    0) {
                                                                                    peg$fail(peg$c72);
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
            if (s1 !== peg$FAILED) {
                s2 = peg$currPos;
                peg$silentFails++;
                s3 = peg$parseIDENTIFIER_CHARACTER();
                peg$silentFails--;
                if (s3 === peg$FAILED) {
                    s2 = void 0;
                }
                else {
                    peg$currPos = s2;
                    s2 = peg$FAILED;
                }
                if (s2 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c38(s1);
                    s0 = s1;
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parseCONNECTOR() {
            var s0, s1, s2, s3;
            s0 = peg$currPos;
            if (input.substr(peg$currPos, 3).toLowerCase() === peg$c73) {
                s1 = input.substr(peg$currPos, 3);
                peg$currPos += 3;
            }
            else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$c74);
                }
            }
            if (s1 === peg$FAILED) {
                if (input.substr(peg$currPos, 2).toLowerCase() === peg$c75) {
                    s1 = input.substr(peg$currPos, 2);
                    peg$currPos += 2;
                }
                else {
                    s1 = peg$FAILED;
                    if (peg$silentFails === 0) {
                        peg$fail(peg$c76);
                    }
                }
            }
            if (s1 !== peg$FAILED) {
                s2 = peg$currPos;
                peg$silentFails++;
                s3 = peg$parseIDENTIFIER_CHARACTER();
                peg$silentFails--;
                if (s3 === peg$FAILED) {
                    s2 = void 0;
                }
                else {
                    peg$currPos = s2;
                    s2 = peg$FAILED;
                }
                if (s2 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c77(s1);
                    s0 = s1;
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parseRESERVED_CONNECTOR() {
            var s0, s1, s2, s3;
            s0 = peg$currPos;
            if (input.substr(peg$currPos, 3).toLowerCase() === peg$c73) {
                s1 = input.substr(peg$currPos, 3);
                peg$currPos += 3;
            }
            else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$c74);
                }
            }
            if (s1 === peg$FAILED) {
                if (input.substr(peg$currPos, 2).toLowerCase() === peg$c75) {
                    s1 = input.substr(peg$currPos, 2);
                    peg$currPos += 2;
                }
                else {
                    s1 = peg$FAILED;
                    if (peg$silentFails === 0) {
                        peg$fail(peg$c76);
                    }
                }
            }
            if (s1 !== peg$FAILED) {
                s2 = peg$currPos;
                peg$silentFails++;
                s3 = peg$parseIDENTIFIER_CHARACTER();
                peg$silentFails--;
                if (s3 === peg$FAILED) {
                    s2 = void 0;
                }
                else {
                    peg$currPos = s2;
                    s2 = peg$FAILED;
                }
                if (s2 !== peg$FAILED) {
                    s1 = [s1, s2];
                    s0 = s1;
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parseIDENTIFIER_CHARACTER() {
            var s0;
            if (peg$c25.test(input.charAt(peg$currPos))) {
                s0 = input.charAt(peg$currPos);
                peg$currPos++;
            }
            else {
                s0 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$c26);
                }
            }
            return s0;
        }
        function peg$parseARGUMENTS() {
            var s0, s1, s2, s3, s4, s5, s6, s7;
            s0 = peg$currPos;
            s1 = peg$parseSCALAR();
            if (s1 !== peg$FAILED) {
                s2 = [];
                s3 = peg$currPos;
                s4 = peg$parse_();
                if (s4 !== peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 44) {
                        s5 = peg$c11;
                        peg$currPos++;
                    }
                    else {
                        s5 = peg$FAILED;
                        if (peg$silentFails === 0) {
                            peg$fail(peg$c12);
                        }
                    }
                    if (s5 !== peg$FAILED) {
                        s6 = peg$parse_();
                        if (s6 !== peg$FAILED) {
                            s7 = peg$parseSCALAR();
                            if (s7 !== peg$FAILED) {
                                peg$savedPos = s3;
                                s4 = peg$c78(s1, s7);
                                s3 = s4;
                            }
                            else {
                                peg$currPos = s3;
                                s3 = peg$FAILED;
                            }
                        }
                        else {
                            peg$currPos = s3;
                            s3 = peg$FAILED;
                        }
                    }
                    else {
                        peg$currPos = s3;
                        s3 = peg$FAILED;
                    }
                }
                else {
                    peg$currPos = s3;
                    s3 = peg$FAILED;
                }
                while (s3 !== peg$FAILED) {
                    s2.push(s3);
                    s3 = peg$currPos;
                    s4 = peg$parse_();
                    if (s4 !== peg$FAILED) {
                        if (input.charCodeAt(peg$currPos) === 44) {
                            s5 = peg$c11;
                            peg$currPos++;
                        }
                        else {
                            s5 = peg$FAILED;
                            if (peg$silentFails === 0) {
                                peg$fail(peg$c12);
                            }
                        }
                        if (s5 !== peg$FAILED) {
                            s6 = peg$parse_();
                            if (s6 !== peg$FAILED) {
                                s7 = peg$parseSCALAR();
                                if (s7 !== peg$FAILED) {
                                    peg$savedPos = s3;
                                    s4 = peg$c78(s1, s7);
                                    s3 = s4;
                                }
                                else {
                                    peg$currPos = s3;
                                    s3 = peg$FAILED;
                                }
                            }
                            else {
                                peg$currPos = s3;
                                s3 = peg$FAILED;
                            }
                        }
                        else {
                            peg$currPos = s3;
                            s3 = peg$FAILED;
                        }
                    }
                    else {
                        peg$currPos = s3;
                        s3 = peg$FAILED;
                    }
                }
                if (s2 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c79(s1, s2);
                    s0 = s1;
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parseSCALAR() {
            var s0;
            s0 = peg$parseBARE_NULL();
            if (s0 === peg$FAILED) {
                s0 = peg$parseSINGLE_QUOTED_SCALAR();
                if (s0 === peg$FAILED) {
                    s0 = peg$parseDOUBLE_QUOTED_SCALAR();
                    if (s0 === peg$FAILED) {
                        s0 = peg$parseBARE_SCALAR();
                    }
                }
            }
            return s0;
        }
        function peg$parseBARE_NULL() {
            var s0, s1, s2, s3;
            s0 = peg$currPos;
            s1 = peg$currPos;
            if (input.substr(peg$currPos, 4).toLowerCase() === peg$c80) {
                s2 = input.substr(peg$currPos, 4);
                peg$currPos += 4;
            }
            else {
                s2 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$c81);
                }
            }
            if (s2 !== peg$FAILED) {
                s1 = input.substring(s1, peg$currPos);
            }
            else {
                s1 = s2;
            }
            if (s1 !== peg$FAILED) {
                s2 = peg$currPos;
                peg$silentFails++;
                s3 = peg$parseBARE_CHARACTER();
                peg$silentFails--;
                if (s3 === peg$FAILED) {
                    s2 = void 0;
                }
                else {
                    peg$currPos = s2;
                    s2 = peg$FAILED;
                }
                if (s2 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c82(s1);
                    s0 = s1;
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parseBARE_SCALAR() {
            var s0, s1, s2, s3, s4, s5, s6;
            s0 = peg$currPos;
            s1 = peg$currPos;
            peg$silentFails++;
            s2 = peg$parseRESERVED_SCALAR();
            peg$silentFails--;
            if (s2 === peg$FAILED) {
                s1 = void 0;
            }
            else {
                peg$currPos = s1;
                s1 = peg$FAILED;
            }
            if (s1 !== peg$FAILED) {
                s2 = peg$currPos;
                s3 = [];
                s4 = peg$currPos;
                s5 = peg$currPos;
                peg$silentFails++;
                s6 = peg$parseBARE_DELIMITER();
                peg$silentFails--;
                if (s6 === peg$FAILED) {
                    s5 = void 0;
                }
                else {
                    peg$currPos = s5;
                    s5 = peg$FAILED;
                }
                if (s5 !== peg$FAILED) {
                    if (input.length > peg$currPos) {
                        s6 = input.charAt(peg$currPos);
                        peg$currPos++;
                    }
                    else {
                        s6 = peg$FAILED;
                        if (peg$silentFails === 0) {
                            peg$fail(peg$c0);
                        }
                    }
                    if (s6 !== peg$FAILED) {
                        s5 = [s5, s6];
                        s4 = s5;
                    }
                    else {
                        peg$currPos = s4;
                        s4 = peg$FAILED;
                    }
                }
                else {
                    peg$currPos = s4;
                    s4 = peg$FAILED;
                }
                if (s4 !== peg$FAILED) {
                    while (s4 !== peg$FAILED) {
                        s3.push(s4);
                        s4 = peg$currPos;
                        s5 = peg$currPos;
                        peg$silentFails++;
                        s6 = peg$parseBARE_DELIMITER();
                        peg$silentFails--;
                        if (s6 === peg$FAILED) {
                            s5 = void 0;
                        }
                        else {
                            peg$currPos = s5;
                            s5 = peg$FAILED;
                        }
                        if (s5 !== peg$FAILED) {
                            if (input.length > peg$currPos) {
                                s6 = input.charAt(peg$currPos);
                                peg$currPos++;
                            }
                            else {
                                s6 = peg$FAILED;
                                if (peg$silentFails === 0) {
                                    peg$fail(peg$c0);
                                }
                            }
                            if (s6 !== peg$FAILED) {
                                s5 = [s5, s6];
                                s4 = s5;
                            }
                            else {
                                peg$currPos = s4;
                                s4 = peg$FAILED;
                            }
                        }
                        else {
                            peg$currPos = s4;
                            s4 = peg$FAILED;
                        }
                    }
                }
                else {
                    s3 = peg$FAILED;
                }
                if (s3 !== peg$FAILED) {
                    s2 = input.substring(s2, peg$currPos);
                }
                else {
                    s2 = s3;
                }
                if (s2 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c83(s2);
                    s0 = s1;
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parseRESERVED_SCALAR() {
            var s0, s1, s2, s3;
            s0 = peg$currPos;
            if (input.substr(peg$currPos, 3).toLowerCase() === peg$c73) {
                s1 = input.substr(peg$currPos, 3);
                peg$currPos += 3;
            }
            else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$c74);
                }
            }
            if (s1 === peg$FAILED) {
                if (input.substr(peg$currPos, 2).toLowerCase() === peg$c75) {
                    s1 = input.substr(peg$currPos, 2);
                    peg$currPos += 2;
                }
                else {
                    s1 = peg$FAILED;
                    if (peg$silentFails === 0) {
                        peg$fail(peg$c76);
                    }
                }
                if (s1 === peg$FAILED) {
                    if (input.substr(peg$currPos, 4).toLowerCase() === peg$c80) {
                        s1 = input.substr(peg$currPos, 4);
                        peg$currPos += 4;
                    }
                    else {
                        s1 = peg$FAILED;
                        if (peg$silentFails === 0) {
                            peg$fail(peg$c81);
                        }
                    }
                }
            }
            if (s1 !== peg$FAILED) {
                s2 = peg$currPos;
                peg$silentFails++;
                s3 = peg$parseBARE_CHARACTER();
                peg$silentFails--;
                if (s3 === peg$FAILED) {
                    s2 = void 0;
                }
                else {
                    peg$currPos = s2;
                    s2 = peg$FAILED;
                }
                if (s2 !== peg$FAILED) {
                    s1 = [s1, s2];
                    s0 = s1;
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parseBARE_CHARACTER() {
            var s0, s1, s2;
            s0 = peg$currPos;
            s1 = peg$currPos;
            peg$silentFails++;
            s2 = peg$parseBARE_DELIMITER();
            peg$silentFails--;
            if (s2 === peg$FAILED) {
                s1 = void 0;
            }
            else {
                peg$currPos = s1;
                s1 = peg$FAILED;
            }
            if (s1 !== peg$FAILED) {
                if (input.length > peg$currPos) {
                    s2 = input.charAt(peg$currPos);
                    peg$currPos++;
                }
                else {
                    s2 = peg$FAILED;
                    if (peg$silentFails === 0) {
                        peg$fail(peg$c0);
                    }
                }
                if (s2 !== peg$FAILED) {
                    s1 = [s1, s2];
                    s0 = s1;
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parseBARE_DELIMITER() {
            var s0;
            if (peg$c84.test(input.charAt(peg$currPos))) {
                s0 = input.charAt(peg$currPos);
                peg$currPos++;
            }
            else {
                s0 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$c85);
                }
            }
            return s0;
        }
        function peg$parseSINGLE_QUOTED_SCALAR() {
            var s0, s1, s2, s3;
            s0 = peg$currPos;
            if (input.charCodeAt(peg$currPos) === 39) {
                s1 = peg$c86;
                peg$currPos++;
            }
            else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$c87);
                }
            }
            if (s1 !== peg$FAILED) {
                s2 = [];
                s3 = peg$parseSINGLE_QUOTED_CHARACTER();
                while (s3 !== peg$FAILED) {
                    s2.push(s3);
                    s3 = peg$parseSINGLE_QUOTED_CHARACTER();
                }
                if (s2 !== peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 39) {
                        s3 = peg$c86;
                        peg$currPos++;
                    }
                    else {
                        s3 = peg$FAILED;
                        if (peg$silentFails === 0) {
                            peg$fail(peg$c87);
                        }
                    }
                    if (s3 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c88(s2);
                        s0 = s1;
                    }
                    else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parseSINGLE_QUOTED_CHARACTER() {
            var s0, s1;
            s0 = peg$parseESCAPE();
            if (s0 === peg$FAILED) {
                s0 = peg$currPos;
                if (peg$c89.test(input.charAt(peg$currPos))) {
                    s1 = input.charAt(peg$currPos);
                    peg$currPos++;
                }
                else {
                    s1 = peg$FAILED;
                    if (peg$silentFails === 0) {
                        peg$fail(peg$c90);
                    }
                }
                if (s1 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c33(s1);
                }
                s0 = s1;
            }
            return s0;
        }
        function peg$parseDOUBLE_QUOTED_SCALAR() {
            var s0, s1, s2, s3;
            s0 = peg$currPos;
            if (input.charCodeAt(peg$currPos) === 34) {
                s1 = peg$c91;
                peg$currPos++;
            }
            else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$c92);
                }
            }
            if (s1 !== peg$FAILED) {
                s2 = [];
                s3 = peg$parseDOUBLE_QUOTED_CHARACTER();
                while (s3 !== peg$FAILED) {
                    s2.push(s3);
                    s3 = peg$parseDOUBLE_QUOTED_CHARACTER();
                }
                if (s2 !== peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 34) {
                        s3 = peg$c91;
                        peg$currPos++;
                    }
                    else {
                        s3 = peg$FAILED;
                        if (peg$silentFails === 0) {
                            peg$fail(peg$c92);
                        }
                    }
                    if (s3 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c88(s2);
                        s0 = s1;
                    }
                    else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parseDOUBLE_QUOTED_CHARACTER() {
            var s0, s1;
            s0 = peg$parseESCAPE();
            if (s0 === peg$FAILED) {
                s0 = peg$currPos;
                if (peg$c93.test(input.charAt(peg$currPos))) {
                    s1 = input.charAt(peg$currPos);
                    peg$currPos++;
                }
                else {
                    s1 = peg$FAILED;
                    if (peg$silentFails === 0) {
                        peg$fail(peg$c94);
                    }
                }
                if (s1 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c33(s1);
                }
                s0 = s1;
            }
            return s0;
        }
        function peg$parseESCAPE() {
            var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9;
            s0 = peg$currPos;
            if (input.charCodeAt(peg$currPos) === 92) {
                s1 = peg$c95;
                peg$currPos++;
            }
            else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$c96);
                }
            }
            if (s1 !== peg$FAILED) {
                if (input.charCodeAt(peg$currPos) === 39) {
                    s2 = peg$c86;
                    peg$currPos++;
                }
                else {
                    s2 = peg$FAILED;
                    if (peg$silentFails === 0) {
                        peg$fail(peg$c87);
                    }
                }
                if (s2 === peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 34) {
                        s2 = peg$c91;
                        peg$currPos++;
                    }
                    else {
                        s2 = peg$FAILED;
                        if (peg$silentFails === 0) {
                            peg$fail(peg$c92);
                        }
                    }
                    if (s2 === peg$FAILED) {
                        if (input.charCodeAt(peg$currPos) === 96) {
                            s2 = peg$c28;
                            peg$currPos++;
                        }
                        else {
                            s2 = peg$FAILED;
                            if (peg$silentFails === 0) {
                                peg$fail(peg$c29);
                            }
                        }
                        if (s2 === peg$FAILED) {
                            if (input.charCodeAt(peg$currPos) === 92) {
                                s2 = peg$c95;
                                peg$currPos++;
                            }
                            else {
                                s2 = peg$FAILED;
                                if (peg$silentFails === 0) {
                                    peg$fail(peg$c96);
                                }
                            }
                            if (s2 === peg$FAILED) {
                                if (input.charCodeAt(peg$currPos) === 47) {
                                    s2 = peg$c97;
                                    peg$currPos++;
                                }
                                else {
                                    s2 = peg$FAILED;
                                    if (peg$silentFails === 0) {
                                        peg$fail(peg$c98);
                                    }
                                }
                                if (s2 === peg$FAILED) {
                                    s2 = peg$currPos;
                                    if (input.charCodeAt(peg$currPos) === 98) {
                                        s3 = peg$c99;
                                        peg$currPos++;
                                    }
                                    else {
                                        s3 = peg$FAILED;
                                        if (peg$silentFails === 0) {
                                            peg$fail(peg$c100);
                                        }
                                    }
                                    if (s3 !== peg$FAILED) {
                                        peg$savedPos = s2;
                                        s3 = peg$c101();
                                    }
                                    s2 = s3;
                                    if (s2 === peg$FAILED) {
                                        s2 = peg$currPos;
                                        if (input.charCodeAt(peg$currPos) ===
                                            102) {
                                            s3 = peg$c102;
                                            peg$currPos++;
                                        }
                                        else {
                                            s3 = peg$FAILED;
                                            if (peg$silentFails === 0) {
                                                peg$fail(peg$c103);
                                            }
                                        }
                                        if (s3 !== peg$FAILED) {
                                            peg$savedPos = s2;
                                            s3 = peg$c104();
                                        }
                                        s2 = s3;
                                        if (s2 === peg$FAILED) {
                                            s2 = peg$currPos;
                                            if (input.charCodeAt(peg$currPos) === 110) {
                                                s3 = peg$c105;
                                                peg$currPos++;
                                            }
                                            else {
                                                s3 = peg$FAILED;
                                                if (peg$silentFails === 0) {
                                                    peg$fail(peg$c106);
                                                }
                                            }
                                            if (s3 !== peg$FAILED) {
                                                peg$savedPos = s2;
                                                s3 = peg$c107();
                                            }
                                            s2 = s3;
                                            if (s2 === peg$FAILED) {
                                                s2 = peg$currPos;
                                                if (input.charCodeAt(peg$currPos) === 114) {
                                                    s3 = peg$c108;
                                                    peg$currPos++;
                                                }
                                                else {
                                                    s3 = peg$FAILED;
                                                    if (peg$silentFails === 0) {
                                                        peg$fail(peg$c109);
                                                    }
                                                }
                                                if (s3 !== peg$FAILED) {
                                                    peg$savedPos = s2;
                                                    s3 = peg$c110();
                                                }
                                                s2 = s3;
                                                if (s2 === peg$FAILED) {
                                                    s2 = peg$currPos;
                                                    if (input.charCodeAt(peg$currPos) === 116) {
                                                        s3 = peg$c111;
                                                        peg$currPos++;
                                                    }
                                                    else {
                                                        s3 = peg$FAILED;
                                                        if (peg$silentFails ===
                                                            0) {
                                                            peg$fail(peg$c112);
                                                        }
                                                    }
                                                    if (s3 !== peg$FAILED) {
                                                        peg$savedPos = s2;
                                                        s3 = peg$c113();
                                                    }
                                                    s2 = s3;
                                                    if (s2 === peg$FAILED) {
                                                        s2 = peg$currPos;
                                                        if (input.charCodeAt(peg$currPos) === 117) {
                                                            s3 = peg$c114;
                                                            peg$currPos++;
                                                        }
                                                        else {
                                                            s3 = peg$FAILED;
                                                            if (peg$silentFails ===
                                                                0) {
                                                                peg$fail(peg$c115);
                                                            }
                                                        }
                                                        if (s3 !== peg$FAILED) {
                                                            s4 = peg$currPos;
                                                            s5 = peg$currPos;
                                                            if (peg$c116.test(input.charAt(peg$currPos))) {
                                                                s6 =
                                                                    input.charAt(peg$currPos);
                                                                peg$currPos++;
                                                            }
                                                            else {
                                                                s6 = peg$FAILED;
                                                                if (peg$silentFails ===
                                                                    0) {
                                                                    peg$fail(peg$c117);
                                                                }
                                                            }
                                                            if (s6 !==
                                                                peg$FAILED) {
                                                                if (peg$c116.test(input.charAt(peg$currPos))) {
                                                                    s7 =
                                                                        input.charAt(peg$currPos);
                                                                    peg$currPos++;
                                                                }
                                                                else {
                                                                    s7 =
                                                                        peg$FAILED;
                                                                    if (peg$silentFails ===
                                                                        0) {
                                                                        peg$fail(peg$c117);
                                                                    }
                                                                }
                                                                if (s7 !==
                                                                    peg$FAILED) {
                                                                    if (peg$c116.test(input.charAt(peg$currPos))) {
                                                                        s8 =
                                                                            input.charAt(peg$currPos);
                                                                        peg$currPos++;
                                                                    }
                                                                    else {
                                                                        s8 =
                                                                            peg$FAILED;
                                                                        if (peg$silentFails ===
                                                                            0) {
                                                                            peg$fail(peg$c117);
                                                                        }
                                                                    }
                                                                    if (s8 !==
                                                                        peg$FAILED) {
                                                                        if (peg$c116.test(input.charAt(peg$currPos))) {
                                                                            s9 =
                                                                                input.charAt(peg$currPos);
                                                                            peg$currPos++;
                                                                        }
                                                                        else {
                                                                            s9 =
                                                                                peg$FAILED;
                                                                            if (peg$silentFails ===
                                                                                0) {
                                                                                peg$fail(peg$c117);
                                                                            }
                                                                        }
                                                                        if (s9 !==
                                                                            peg$FAILED) {
                                                                            s6 =
                                                                                [
                                                                                    s6,
                                                                                    s7,
                                                                                    s8,
                                                                                    s9,
                                                                                ];
                                                                            s5 =
                                                                                s6;
                                                                        }
                                                                        else {
                                                                            peg$currPos =
                                                                                s5;
                                                                            s5 =
                                                                                peg$FAILED;
                                                                        }
                                                                    }
                                                                    else {
                                                                        peg$currPos =
                                                                            s5;
                                                                        s5 =
                                                                            peg$FAILED;
                                                                    }
                                                                }
                                                                else {
                                                                    peg$currPos =
                                                                        s5;
                                                                    s5 =
                                                                        peg$FAILED;
                                                                }
                                                            }
                                                            else {
                                                                peg$currPos =
                                                                    s5;
                                                                s5 = peg$FAILED;
                                                            }
                                                            if (s5 !==
                                                                peg$FAILED) {
                                                                s4 =
                                                                    input.substring(s4, peg$currPos);
                                                            }
                                                            else {
                                                                s4 = s5;
                                                            }
                                                            if (s4 !==
                                                                peg$FAILED) {
                                                                peg$savedPos =
                                                                    s2;
                                                                s3 =
                                                                    peg$c118(s4);
                                                                s2 = s3;
                                                            }
                                                            else {
                                                                peg$currPos =
                                                                    s2;
                                                                s2 = peg$FAILED;
                                                            }
                                                        }
                                                        else {
                                                            peg$currPos = s2;
                                                            s2 = peg$FAILED;
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                if (s2 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c119(s2);
                    s0 = s1;
                }
                else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parse_() {
            var s0, s1;
            s0 = [];
            if (peg$c120.test(input.charAt(peg$currPos))) {
                s1 = input.charAt(peg$currPos);
                peg$currPos++;
            }
            else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$c121);
                }
            }
            while (s1 !== peg$FAILED) {
                s0.push(s1);
                if (peg$c120.test(input.charAt(peg$currPos))) {
                    s1 = input.charAt(peg$currPos);
                    peg$currPos++;
                }
                else {
                    s1 = peg$FAILED;
                    if (peg$silentFails === 0) {
                        peg$fail(peg$c121);
                    }
                }
            }
            return s0;
        }
        function peg$parse__() {
            var s0, s1;
            s0 = [];
            if (peg$c120.test(input.charAt(peg$currPos))) {
                s1 = input.charAt(peg$currPos);
                peg$currPos++;
            }
            else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) {
                    peg$fail(peg$c121);
                }
            }
            if (s1 !== peg$FAILED) {
                while (s1 !== peg$FAILED) {
                    s0.push(s1);
                    if (peg$c120.test(input.charAt(peg$currPos))) {
                        s1 = input.charAt(peg$currPos);
                        peg$currPos++;
                    }
                    else {
                        s1 = peg$FAILED;
                        if (peg$silentFails === 0) {
                            peg$fail(peg$c121);
                        }
                    }
                }
            }
            else {
                s0 = peg$FAILED;
            }
            return s0;
        }
        function node(kind, value, span) {
            return { kind: kind, value: value, span: span };
        }
        peg$result = peg$startRuleFunction();
        if (peg$result !== peg$FAILED && peg$currPos === input.length) {
            return peg$result;
        }
        else {
            if (peg$result !== peg$FAILED && peg$currPos < input.length) {
                peg$fail(peg$endExpectation());
            }
            throw peg$buildStructuredError(peg$maxFailExpected, peg$maxFailPos < input.length
                ? input.charAt(peg$maxFailPos)
                : null, peg$maxFailPos < input.length
                ? peg$computeLocation(peg$maxFailPos, peg$maxFailPos + 1)
                : peg$computeLocation(peg$maxFailPos, peg$maxFailPos));
        }
    }
    return {
        SyntaxError: peg$SyntaxError,
        parse: peg$parse,
    };
})();
//# sourceMappingURL=parser.js.map